import {IconButton, Stack} from "@mui/material";
import {GitHub, Home, X, YouTube} from "@mui/icons-material";
import React from "react";
import {Link} from "react-router-dom";
import {useTheme} from "@mui/material/styles";

const IconButtonStyled = ({children, to}) => {
  return (
    <IconButton
      component={Link}
      to={to}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        transition: 'transform 0.2s, box-shadow 0.2s',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.5)',
            backgroundColor: '#EAEBEF',
          },
      }}
    >
      {children}
    </IconButton>
  );
}

export const LinksIconMenu = ({sx}) => {
  const theme = useTheme();
  return (
    <Stack direction={'row'} sx={sx} justifyContent={'space-between'}>
      <IconButtonStyled to={'https://www.predsci.com'}>
        <Home sx={{fontSize: 'x-large', color: theme.palette.blues.rothko2}} />
      </IconButtonStyled>
      <IconButtonStyled to={'https://www.youtube.com/@PredictiveScienceInc'}>
        <YouTube sx={{fontSize: 'x-large', color: theme.palette.blues.rothko2}}/>
      </IconButtonStyled>
      <IconButtonStyled to={'https://github.com/predsci'}>
        <GitHub sx={{fontSize: 'x-large', color: theme.palette.blues.rothko2}}/>
      </IconButtonStyled>
      <IconButtonStyled to={'https://x.com/predsci'}>
        <X sx={{fontSize: 'x-large', color: theme.palette.blues.rothko2}}/>
      </IconButtonStyled>
    </Stack>
  );
}